// extracted by mini-css-extract-plugin
export default {"table-container":"CustomTable_table-container__BYMDL"};